type AddressLike = {
  street?: string | null;
  houseNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
};

export const formatOrganizationAddress = (
  address?: AddressLike | null
): string | undefined => {
  if (!address) {
    return undefined;
  }

  const parts: string[] = [];

  const streetLine = [address.street?.trim(), address.houseNumber?.trim()]
    .filter(Boolean)
    .join(' ');
  if (streetLine) {
    parts.push(streetLine);
  }

  const cityLine = [address.postalCode?.trim(), address.city?.trim()]
    .filter(Boolean)
    .join(' ');
  if (cityLine) {
    parts.push(cityLine);
  }

  if (!parts.length) {
    return undefined;
  }

  return parts.join(', ');
};
